import { styled } from '@linaria/react';
import type { DeliveryChannel } from '../../../../api/automations-workflows-client/automations-workflows-client.type';
import { AgentDeliveryChannels } from '../agent-delivery-channels/agent-delivery-channels';

interface AgentAutomationDeliveryConfigProps {
  initialChannels: DeliveryChannel[];
  userEmail: string;
  userId: string | null;
  onChange: (channels: DeliveryChannel[]) => void;
  onValidityChange: (isValid: boolean) => void;
}

export function AgentAutomationDeliveryConfig({
  initialChannels,
  userEmail,
  userId,
  onChange,
  onValidityChange,
}: AgentAutomationDeliveryConfigProps) {
  return (
    <Wrapper>
      <AgentDeliveryChannels
        value={initialChannels}
        onChange={onChange}
        onValidityChange={onValidityChange}
        userEmail={userEmail}
        userId={userId}
        fieldIdPrefix="automation"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export type { AgentAutomationDeliveryConfigProps };
